export type UpdateTeamErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class UpdateTeamError extends Error {
    code: UpdateTeamErrorCode;

    constructor(code: UpdateTeamErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
